export default __webpack_public_path__ + "09e0bd9014e9090a926ac19fc787eb6c.png";